import { UserPayload } from "../models/SiteModel";

const URLAPI = process.env.REACT_APP_BASE_URL;

export type McpConnectionStatus = {
  provider: string;
  connected: boolean;
  authorizedAt: string | null;
  available: boolean;
  clientId: string | null;
};

export async function fetchEstablecerSesionOAuth(user: UserPayload): Promise<void> {
  const response = await fetch(`${URLAPI}/Auth/EstablecerSesionOAuth`, {
    method: "POST",
    credentials: "include",
    headers: { Authorization: `Bearer ${user.token}` },
  });
  if (!response.ok) throw new Error("No se pudo sincronizar la sesión GenFE para autorizar conectores.");
}

export async function fetchMcpConnections(user: UserPayload): Promise<McpConnectionStatus[]> {
  const response = await fetch(`${URLAPI}/mcp/connections`, {
    method: "GET",
    cache: "no-store",
    headers: { Authorization: `Bearer ${user.token}` },
  });
  if (!response.ok) throw new Error("No se pudo consultar el estado de las conexiones MCP.");
  return response.json();
}

export async function fetchRevocarMcpConnection(user: UserPayload, provider: string): Promise<void> {
  const response = await fetch(`${URLAPI}/mcp/connections/${encodeURIComponent(provider)}/revoke`, {
    method: "POST",
    headers: { Authorization: `Bearer ${user.token}` },
  });
  if (!response.ok) {
    throw new Error(`No se pudo revocar la conexión con ${provider} (HTTP ${response.status}).`);
  }
}
